import fadedBlackFront from "../assets/merch/garments/ascolour-5082/faded-black-front.png";
import fadedBlackBack from "../assets/merch/garments/ascolour-5082/faded-black-back.png";
import fadedCoalFront from "../assets/merch/garments/ascolour-5082/faded-coal-front.png";
import fadedCoalBack from "../assets/merch/garments/ascolour-5082/faded-coal-back.png";
import fadedBoneFront from "../assets/merch/garments/ascolour-5082/faded-bone-front.png";
import fadedBoneBack from "../assets/merch/garments/ascolour-5082/faded-bone-back.png";

export const merchGarmentAssets = {
  "ascolour-5082": {
    "Faded Black": { front: fadedBlackFront, back: fadedBlackBack },
    "Faded Coal": { front: fadedCoalFront, back: fadedCoalBack },
    "Faded Bone": { front: fadedBoneFront, back: fadedBoneBack }
  }
};

export function getMerchGarmentAsset(garmentId, color, view) {
  return merchGarmentAssets[garmentId]?.[color]?.[view] || null;
}
